export const environment = {
  production: true,
  apiBasePath: 'https://api.applucor.com.br',
  version: '2025-04-25_2053'
};
